const defaultState = {};
export default (state: any = defaultState, action: any) => {
  const nextState = { ...state };
  switch (action.type) {
    default:
      return nextState;
  }
};
